import(/* webpackMode: "eager" */ "/builds/dustintech/dev/dustintech/web/libraries/dustin-microsite/apps/contentsite/src/app/global-error.tsx");
